var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4569_67099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4569_67099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25C10.7143 21.25 9.51586 21.0066 8.39715 20.5239C7.26388 20.0349 6.28556 19.3749 5.45533 18.5447C4.6251 17.7144 3.96514 16.7361 3.47612 15.6029C2.99339 14.4841 2.75 13.2857 2.75 12C2.75 10.7143 2.99339 9.51586 3.47612 8.39715C3.96514 7.26388 4.6251 6.28556 5.45533 5.45533C6.28556 4.6251 7.26388 3.96514 8.39715 3.47612C9.51586 2.99339 10.7143 2.75 12 2.75C13.2857 2.75 14.4841 2.99339 15.6029 3.47612C16.7361 3.96514 17.7144 4.6251 18.5447 5.45533C19.3749 6.28556 20.0349 7.26388 20.5239 8.39715C21.0066 9.51586 21.25 10.7143 21.25 12C21.25 13.2857 21.0066 14.4841 20.5239 15.6029C20.0349 16.7361 19.3749 17.7144 18.5447 18.5447C17.7144 19.3749 16.7361 20.0349 15.6029 20.5239C14.4841 21.0066 13.2857 21.25 12 21.25Z",
    stroke: "#BCC2CB",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6501 9.5499L10.6001 16.5999L6.3501 12.3499L7.7501 10.9499L10.6001 13.7999L16.2501 8.1499L17.6501 9.5499Z",
    fill: "#BCC2CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/gray_check.493c2b88f84ce7673deadd713decce16.svg";
export { ForwardRef as ReactComponent };